import { render, staticRenderFns } from "./NewsCont.vue?vue&type=template&id=9f3ec280&scoped=true"
import script from "./NewsCont.vue?vue&type=script&lang=js"
export * from "./NewsCont.vue?vue&type=script&lang=js"
import style0 from "./NewsCont.vue?vue&type=style&index=0&id=9f3ec280&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f3ec280",
  null
  
)

export default component.exports